import React from "react";
import { List, ListSubheader, SxProps } from "@mui/material";
import { MenuItemType } from "../../../../../types/menu.type";
import { isArray } from "lodash";
import SidebarItem from "./SidebarItem";
import { useLocation } from "react-router-dom";

interface ISidebarList {
  sx?: SxProps;
  subheaderText?: string;
  items?: MenuItemType[];
}

function SidebarList({ subheaderText, sx, items, ...props }: ISidebarList) {
  const location = useLocation();

  return (
    <List
      component="nav"
      subheader={
        subheaderText ? (
          <ListSubheader sx={{ px: 0 }}>{subheaderText}</ListSubheader>
        ) : null
      }
      sx={{ px: 2, ...sx }}
      {...props}
    >
      {isArray(items) &&
        items.map((item, index) => {
          let active = item.path === "/" && location.pathname === "/";
          if (item.path && item.path !== "/") {
            active = location.pathname.includes(item.path);
          }

          return (
            <SidebarItem
              key={index}
              text={item.text}
              Icon={item.Icon}
              href={item.path}
              active={active}
            />
          );
        })}
    </List>
  );
}

export default SidebarList;
